<template>
  <VContainer
    fluid
    class="articles py-10"
  >
    <VRow>
      <VCol
        v-for="article in articlesList"
        :key="article._id"
        class="pb-0 pt-6"
        cols="6"
        lg="6"
        md="12"
        sm="12"
        xs="12"
      >
        <RouterLink
          :to="{
            name: 'Article',
            params: {
              name: article.slug,
            },
          }"
          class="articles__link"
        >
          <VCard class="p-4 articles__card">
            <img
              v-if="article.titlePicture && article.titlePicture.url"
              :src="article.titlePicture.url"
              class="mr-2 mb-2 articles__image"
              :alt="$t('imageAlt.articleCoverImage', { title: article.title })"
            >
            <h1>
              {{ article.title }}
            </h1>
            <div class="articles__text">
              {{ article.text }}
            </div>
          </VCard>
        </RouterLink>
      </VCol>
    </VRow>
  </VContainer>
</template>

<script lang="ts">
export default {
  name: 'ArticlesPage',
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import StrapiService from '@slg/web-customer-shared/src/services/StrapiService';
import { useCmsLocaleReload } from '../../composables';

const articlesList = ref<unknown[]>([]);

async function loadCmsData() {
  try {
    articlesList.value = await StrapiService.getArticles();
  } catch (e) {
    articlesList.value = [];
  }
}

useCmsLocaleReload(loadCmsData);
</script>

<style scoped lang="scss">
.articles {
  &__image {
    float: left;
    max-height: 100px;
    max-width: 100px;
    object-fit: contain;
  }

  &__link {
    &:hover {
      text-decoration: none !important;
    }
  }

  &__card {
    height: 200px;
    overflow: hidden;

    &:hover {
      text-decoration: none !important;
    }
  }

  &__text {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 9;
  }
}
</style>
